import { TFocusableElement } from 'src/contexts/FocusContext';
import { FOCUS_GROUPS_ORDER_PRIORITY } from './FocusProvider.constants';

const sortByOrder = (ascending: boolean) => {
  return (a: { order: number }, b: { order: number }) => (ascending ? a.order - b.order : b.order - a.order);
};
export const sortFocusableElements = (
  currentFocusGroups: TFocusableElement['group'][] | null,
  focusableElements: TFocusableElement[],
  needToFocusNextElement: boolean,
) => {
  // filter only focusable elements
  const currentFocusableElements = focusableElements.filter(
    ({ focusable, group }) => focusable && (!currentFocusGroups || currentFocusGroups.some(g => g === group)),
  );

  if (currentFocusableElements.length > 0) {
    // create a map of focusable elements grouped by focus group
    const currentFocusableElementsGroupedByFocusGroup = currentFocusableElements.reduce<{
      [group: string]: { elements: TFocusableElement[]; order: number };
    }>((acc, focusableElement) => {
      const order = FOCUS_GROUPS_ORDER_PRIORITY.findIndex(group => group === focusableElement.group);
      return {
        ...acc,
        [focusableElement.group]: {
          elements: [...(acc[focusableElement.group]?.elements || []), focusableElement],
          order: order >= 0 ? order : 100, //low priority
        },
      };
    }, {});

    // use order priority to sort the focusable elements
    const sortedCurrentFocusableElementsGroupedByFocusGroup = Object.values(
      currentFocusableElementsGroupedByFocusGroup,
    ).sort(sortByOrder(needToFocusNextElement));

    // flat all the focusable elements and sort them
    return sortedCurrentFocusableElementsGroupedByFocusGroup.reduce<TFocusableElement[]>((acc, { elements }) => {
      const sortedElements = elements.sort(sortByOrder(needToFocusNextElement));
      return [...acc, ...sortedElements];
    }, []);
  } else {
    return [];
  }
};
